export default "__VITE_ASSET__BmRP6boP__"